import { batchDispatchMiddleware } from 'redux-batched-actions';
import { withExtraArgument } from 'redux-thunk';

import { apmReduxMiddleware } from '@gef-ui/apm/instruments/redux/middlewares';
import delegationApiInterceptor from '@gef-ui/delegations/middleware/delegationApiInterceptor';
import { middlewareGlobalHandler } from '@gef-ui/error-report-material';
import { streamStorageMiddleware, thunkApi } from '@gef-ui/form-core/redux/streamStorage';
import { oauth2MiddlewareAuthV2 } from '@gef-ui/middleware-api/middleware';
import { cacheMiddleware } from '@gef-ui/middleware-api/middleware/cache';
import { reactiveApiMiddleware } from '@gef-ui/middleware-api/middleware/reactiveApi';
import { statusMiddleware } from '@gef-ui/middleware-api/middleware/status';

import { appUser, buildInfo } from 'features/common/fetch/beEndpoints';
import history from 'utils/history';

export default (authClient, _, getUser, errorDispatch) => [
	statusMiddleware(),
	cacheMiddleware(),
	delegationApiInterceptor({
		excludeEndpoints: [appUser, buildInfo],
	}),
	oauth2MiddlewareAuthV2(undefined, authClient),
	reactiveApiMiddleware(),
	withExtraArgument({
		...thunkApi,
		pushFn: ({ route, args }) => history.push(route, args),
		getLocationFn: () => history.location,
	}),
	apmReduxMiddleware(),
	batchDispatchMiddleware,
	streamStorageMiddleware,
	middlewareGlobalHandler({ errorDispatch, getUser }),
];
